/*LIBRARY*/
import { connect } from "react-redux";

/*COMPONENT*/
// import { Dropdown } from "../reuseable";

/*REDUX*/
import { set_value_properties } from "../../App/actions/propertiesActions";

/*PICTURE*/



/*FUNCTION*/
import useLanguage from "../common_hooks/useLanguage";

/*DATA*/
import referrence_simple_file from "../../Assets/file/[simple-referrence]-[comma-delimited-UTF8].csv";
import { handle_upload_csv } from "../../App/validation/handle_file";
import PreviewReferrenceData from "../common_field/PreviewReferrenceData";

/*CONST*/

const SET_SR = ({
  //variable
  auth,
  layer,
  properties,

  //function
  set_value_properties,
}) => {
  // hooks
  const { language, dict } = useLanguage();

  //state & ref

  //global props
  const { field_editable } = properties || {};
  const { geo_layer_list, layer_id } = layer;
  const { reference_key, reference_list } = field_editable || {};

  //variables
  const geo_layer = geo_layer_list.find(
    (item) => item?.geo_layer?._id === layer_id
  )?.geo_layer;
  const fields = geo_layer?.fields || [];


  //functions
  const handleCsvValidation = async (e) => {
    const file = await handle_upload_csv(e);
    const headers = file?.headers?.map((field) => field.toUpperCase());
    let is_valid = "invalid";

    if (headers?.includes("NAME") && headers?.includes("VALUE")) {
      is_valid = "valid";
    }

    if (is_valid === "valid") {
      set_value_properties({
        key: "field_editable",
        value: {
          ...field_editable,
          reference_list: file.data,
        },
      });
    }
  };

  const referColumn = (e) => {
    set_value_properties({
      key: "field_editable",
      value: {
        ...field_editable,
        reference_key: e.target.value,
      },
    });
  };

  return (
    <main>
      <h1 className="text_bold margin_bottom">Pengaturan Simple Refering</h1>


      <div className="container background_grey_light outline_grey marginBottom_15">
        <label className="font_18 w_full">Simple Referring</label>
        <div className="flex gap_10 paddingTop_10">
          <a
            className="button_big background_black"
            href={referrence_simple_file}
          >
            <div className="center_perfect w_full h_full">
              Template CSV Download
            </div>
          </a>

          <label className="inline">
            <div
              className={`button_big background_black`}
            >
              {"Upload CSV"}
            </div>
            <input
              style={{ display: "none" }}
              type="file"
              accept=".csv*"
              onChange={handleCsvValidation}
            />
          </label>
          {reference_list?.length > 0 && (
            <PreviewReferrenceData
              data={reference_list}
              field={field_editable}
              layer_id={layer_id}
            />
          )}
        </div>
        <div className="paddingTop_10">
          <label htmlFor="refer_to_column" className="font_18">
            {dict["Refer to"][language]}
          </label>
          <select
            id="reference_list"
            name="reference_list"
            value={reference_key}
            onChange={referColumn}
          >
            <option key="" value="">
              {dict["Select Column"][language]}
            </option>
            {fields
              ?.filter((field) => field.key !== field_editable.key)
              .map((field) => {
                return (
                  <option key={field?.key} value={field?.key}>
                    {field?.name}
                  </option>
                );
              })}
            {/* {headers
              ?.filter((header) => header.field !== field_editable.key)
              .map((head) => {
                return (
                  <option key={head.field} value={head.field}>
                    {head.headerName}
                  </option>
                );
              })} */}
          </select>
        </div>
      </div>

      {/* <Dropdown
        placeholder="Pilih"
        filter_on
        is_enable_empty={false}
        value={contoh}
        onChange={(value) => {
          set_value_properties({
            key: "field_editable",
            value: {
              ...field_editable,
              contoh: value,
            },
          });
        }}
      >
        {fields.map((item, idx) => {
          return (
            <option key={item?.key} value={item?.key} id={idx}>
              {item?.name}
            </option>
          );
        })}
      </Dropdown> */}
    </main>
  );
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  layer: state.layer,
  properties: state.properties,
});

export default connect(mapStateToProps, { set_value_properties })(SET_SR);
